import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

// const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/">
        <img width={200} height={250} src="https://news.cornellcollege.edu/2025/05/_images/SeniorProfileSaadMankariousBody.jpg" alt="" />
      </Link>
      <header>
        <h2>Saad Mankarious</h2>
        <p>
          <a href="mailto:michael@mldangelo.com">saadm@gwu.edu</a>
        </p>
      <p>
        Hi, I&apos;m Saad. I am a PhD student at{' '}
        <a href="https://engineering.gwu.edu/">George Washington, DC.</a>
        {/* Previously, I was VP of Engineering at <a href="https://usesmileid.com">SmileID</a>,
        co-founder and CTO of <a href="https://arthena.com">Arthena</a>, and
        co-founded <a href="https://matroid.com">Matroid</a>. */}
      </p>
      <ContactIcons />

      </header>
    </section>
  </section>
);

export default SideBar;
